export const EVENT = {
  DASHBOARD_QUICK_TIP_LEARN_MORE: 'Action: Dashboard: click learn more on tip',
  DASHBOARD_CHANGE_METRIC_DATE_RANGE: 'Action: Dashboard: change metric date range',
  DASHBOARD_CLICK_ON_METRIC: 'Action: Dashboard: click on metric',
  SETTINGS_INVITE_MEMBER: 'Action: Settings: invite member',
  PORTFOLIO_CREATE: 'Action: Portfolio: create new',
  PORTFOLIO_UPDATE: 'Action: Portfolio: update',
  DASHBOARD_PORTFOLIO_CHART_CLICK: 'Action: Click on Portfolio Chart',
  PORTFOLIO_UPDATE_CONTENT: 'Action: Portfolio: update content',
  PORTFOLIO_CONTENT_BUDGET_BOUNDARIES_UPDATE: 'Action: Portfolio: update content budget limits',
  PORTFOLIO_CONTENT_TARGET_BOUNDARIES_UPDATE: 'Action: Portfolio: update content target limits',
  DISABLE_CONTENT_OPTIMIZATION: 'Action: Portfolio: disable content optimization',
  ENABLE_CONTENT_OPTIMIZATION: 'Action: Portfolio: enable content optimization',
  FAVORITE_KPI: 'Action: Kpi: favorite kpi',
  REPORT_KPI_ADD: 'Action: Report: add kpis',
  REPORT_KPI_REMOVE: 'Action: Report: remove kpis',
  REPORT_CREATE_CHANNEL_REPORT: 'Action: Report: create new channel report',
  REPORT_CREATE_KPI_REPORT: 'Action: Report: create new metric report',
  REPORT_UPDATE: 'Action: Report: update',
  REPORT_SHARE: 'Action: Report: share',
  REPORT_DOWNLOAD_PDF: 'Action: Report: pdf download',
  REPORT_DOWNLOAD_XLSX: 'Action: Report: xlsx download',
  METRIC: 'Action: Metric: Change date range',
  CUSTOM_KPI_ADD: 'Action: Custom kpi: add custom kpi',
  TEAM_FEATURE_FLAG_UPDATE: 'Action: Team: update feature flag',
  FUNNEL_CREATE: 'Action: Funnel: create new',
  FUNNEL_UPDATE: 'Action: Funnel: update',
  NOTIFICATION_CLICK_BELL: 'Action: Notification: click bell icon',
  // Routing
  ROUTE_FUNNELS: 'Navigate to: /funnels',
  ROUTE_FUNNEL: 'Navigate to: /funnel',
  ROUTE_PORTFOLIOS: 'Navigate to: /portfolios',
  ROUTE_ATTRIBUTION: 'Navigate to: /attributions',
  ROUTE_PORTFOLIO: 'Navigate to portfolio detail page',
  ROUTE_REPORTS: 'Navigate to: /reports',
  ROUTE_REPORT: 'Navigate to: /report',
  ROUTE_SETTINGS: 'Navigate to: /settings',
  ROUTE_SETTINGS_INTEGRATIONS: 'Navigate to: /settings?tab=integrations',
  ROUTE_CAMPAIGN_MANAGER: 'Navigate to: campaign manager',
  ROUTE_ADHOOK: 'Navigate to: https://app.adhook.io/auth.html?t=66c453d826fed821fa8f6811&prompt=none',
  // Portfolio events
  PORTFOLIO_TAB_CHANGE: (tab: string) => `Action: Portfolio tab switch: ${tab}`,
  PORTFOLIO_SETTINGS_TAB_CHANGE: (tab: string) => `Action: Portfolio settings tab switch: ${tab}`,
  PORTFOLIO_CONTENT_TAB_CHANGE: (tab: string) => `Action: Portfolio content tab switch: ${tab}`,
  DATE_RANGE_CHANGE: 'Action: Date range: change',
  COMPARE_DATE_RANGE_CHANGE: 'Action: Compare date range: change',
  // Performance
  DOWNLOAD_XLSX: 'Action: Download performance table xlsx',
  SWITCH_CHART: 'Action: Switch performance chart',
  PORTFOLIO_FILTER: 'Action: Filter portfolio by provider/label',
  PERFORMANCE_FUNNEL_CUSTOMIZE: 'Action: Funnel: customize',
  // Optimize
  OPTIMIZE_SWITCH_STATUS: (status: string) => `Action: Optimize: switch status to ${status}`,
  APPLY_PROPOSAL_DIALOG: 'Action: Optimize: Clicked on Apply proposal',
  APPLY_PROPOSAL: 'Action: Optimize: Applied proposal',
  DISCARD_PROPOSAL_DIALOG: 'Action: Optimize: Clicked on Discard proposal',
  DISCARD_PROPOSAL: 'Action: Optimize: Discarded proposal',
  MAKE_VISIBLE: 'Action: Optimize: Made visible to all users',
  LAUNCH_OPTIMIZATION_DIALOG: 'Action: Optimize: Clicked on Launch optimization',
  LAUNCH_OPTIMIZATION: 'Action: Optimize: Launched an optimization',
  DOWNLOAD_OPTIMIZATION_REPORT: 'Action: Optimize: Download optimization xlsx',
  SKIP_CONTENT_FROM_PROPOSAL: 'Action: Optimize: Skipped content from proposal',
  INCLUDE_CONTENT_TO_PROPOSAL: 'Action: Optimize: Include content to proposal',
  // Validation
  VALIDATION_SWITCH_VIEW: (view: string) => `Action: Validation: switch view to ${view}`,
  VALIDATION_DOWNLOAD_XLSX: 'Action: Validation: Time-based download xlsx',
  VALIDATION_SHOW_DETAILS: 'Action: Validation: Show details',
  // Budget
  ADD_BUDGET_ITEM_DIALOG: 'Action: Budget: Clicked on Add budget item',
  ADD_BUDGET_ITEM: 'Action: Budget: Added budget item',
  REMOVE_BUDGET_ITEM: 'Action: Budget: Removed budget item',
  UPDATE_BUDGET_ITEM: 'Action: Budget: Updated budget item',
  END_BUDGET_ITEM: 'Action: Budget: Ended budget item',
  // Content
  CONTENT_CHANGE_IMPACT_GROUP: 'Action: Content: Change impact group',
  CONTENT_CHANGE_LABEL: 'Action: Content: Change label',
  CONTENT_DELETE: 'Action: Content: Delete',
  CONTENT_BUDGET_LIMIT_UPDATE: 'Action: Content: Update budget limit',
  CONTENT_EDIT_DIALOG: 'Action: Content: Edit content dialog',
  CONTENT_EDIT_DIALOG_V2: 'Action: Content: Open edit V2 content dialog',
  CONTENT_EDIT: 'Action: Content: Edit content',
  CONTENT_EDIT_V2: 'Action: Content: Edit V2 content',
  CONTENT_EXCLUDE_FROM_OPTIMIZATION: 'Action: Content: Exclude from optimization',
  CONTENT_INCLUDE_IN_OPTIMIZATION: 'Action: Content: Include in optimization',
  // Simulations
  SIMULATION_CREATE: 'Action: Simulation: Click Create simulation',
  SIMULATION_CREATE_DIALOG: 'Action: Simulation: Create',
  SIMULATION_UPDATE: 'Action: Simulation: Update',
  SIMULATION_DELETE: 'Action: Simulation: Delete',
  SIMULATION_ARCHIVE: 'Action: Simulation: Archive',
  SIMULATION_UNARCHIVE: 'Action: Simulation: Unarchive',
  SIMULATION_RUN: 'Action: Simulation: Run',
  SIMULATION_EXPLORE: 'Action: Simulation: Explore',
  SIMULATION_DOWNLOAD_XLSX: 'Action: Simulation: Download xlsx',
  SIMULATION_APPLY_SCENARIO: 'Action: Simulation: Apply scenario',
  SIMULATION_TAB_SWITCH: (tab: string) => `Action: Simulation: Switch tab to ${tab}`,
  // Portfolio funnel steps
  FUNNEL_STEP_EDIT: 'Action: Funnel step: Edit',
  // Events
  PORTFOLIO_EVENT_CREATE: 'Action: Portfolio event: create',
  PORTFOLIO_EVENT_UPDATE: 'Action: Portfolio event: update',
  PORTFOLIO_EVENT_DELETE: 'Action: Portfolio event: delete',
  PORTFOLIO_EVENT_ASSIGN_CONTENTS: 'Action: Portfolio event: assign contents',
  PORTFOLIO_EVENT_UPLOAD_BULK_UPDATE: 'Action: Portfolio event: upload csv file for bulk update',
  PORTFOLIO_EVENT_UPLOAD_BULK_CREATE: 'Action: Portfolio event: upload csv file for bulk create',
  PORTFOLIO_EVENT_SHOW_EVENTS: 'Action: Portfolio event: show events',
  PORTFOLIO_EVENT_EXPORT_CSV: 'Action: Portfolio event: export csv',
  // Performance (revamp) — chart / metrics-over-time
  PERFORMANCE_SELECT_METRIC: 'Action: Performance chart: select metric',
  PERFORMANCE_REMOVE_METRIC: 'Action: Performance chart: remove metric',
  PERFORMANCE_CHANGE_AGGREGATION: 'Action: Performance chart: change aggregation',
  PERFORMANCE_TOGGLE_CHART_VIEW: 'Action: Performance chart: toggle chart view',
  PERFORMANCE_CHANGE_STACK_DIMENSION: 'Action: Performance chart: change area stack dimension',
  PERFORMANCE_TOGGLE_TREND_SIGNAL: 'Action: Performance chart: toggle trend signal',
  PERFORMANCE_CLEAR_TREND_SIGNALS: 'Action: Performance chart: clear trend signals',
  // Performance (revamp) — funnel
  PERFORMANCE_SELECT_FUNNEL_STEP: 'Action: Performance funnel: select step',
  PERFORMANCE_TOGGLE_FUNNEL_VIEW: 'Action: Performance funnel: toggle view',
  PERFORMANCE_OPEN_ATTRIBUTION_INSIGHTS: 'Action: Performance funnel: open attribution insights',
  // Performance (revamp) — filters
  PERFORMANCE_OPEN_FILTERS: 'Action: Performance filters: open drawer',
  PERFORMANCE_APPLY_FILTERS: 'Action: Performance filters: apply',
  PERFORMANCE_CLEAR_FILTERS: 'Action: Performance filters: clear all',
  // Performance (revamp) — table
  PERFORMANCE_APPLY_COLUMNS: 'Action: Performance table: apply columns',
  PERFORMANCE_CHANGE_GROUP_BY: 'Action: Performance table: change group by',
  // Performance (revamp) — screen-level toolbar
  PERFORMANCE_TOGGLE_COMPARE_MODE: 'Action: Performance: toggle compare mode',
  // Performance (revamp) — bookmarks
  PERFORMANCE_APPLY_BOOKMARK: 'Action: Performance bookmark: apply',
  PERFORMANCE_CREATE_BOOKMARK: 'Action: Performance bookmark: create',
  // Performance (revamp) — layouts
  PERFORMANCE_APPLY_LAYOUT: 'Action: Performance layout: apply',
  PERFORMANCE_CREATE_LAYOUT: 'Action: Performance layout: create',
  // Calculated Metric Builder — the rum.nexoya.calcmetric.* generated metrics filter on these exact
  // strings, so renaming one needs a matching Datadog-side change.
  CALC_BUILDER_OPENED: 'calc_builder_opened',
  CALC_TEMPLATE_SELECTED: 'calc_template_selected',
  CALC_PATH_SCRATCH: 'calc_path_scratch',
  CALC_ELEMENT_ADDED: 'calc_element_added',
  CALC_FORMULA_VALID: 'calc_formula_valid',
  CALC_FORMULA_INVALID: 'calc_formula_invalid',
  CALC_PREVIEW_RENDERED: 'calc_preview_rendered',
  CALC_SAVE_BLOCKED: 'calc_save_blocked',
  CALC_PARAM_CREATE_STARTED: 'calc_param_create_started',
  CALC_PARAM_SAVED: 'calc_param_saved',
  CALC_PARAM_ABANDONED: 'calc_param_abandoned',
  CALC_PRESET_CREATE_STARTED: 'calc_preset_create_started',
  CALC_PRESET_SAVED: 'calc_preset_saved',
  CALC_PRESET_ABANDONED: 'calc_preset_abandoned',
  CALC_IMPORT_CREATE_STARTED: 'calc_import_create_started',
  CALC_IMPORT_SAVED: 'calc_import_saved',
  CALC_IMPORT_ABANDONED: 'calc_import_abandoned',
  CALC_APPLY_CANCELLED: 'calc_apply_cancelled',
  CALC_METRIC_APPLIED: 'calc_metric_applied',

  // App Assistant (conversational UI). METADATA ONLY — no payload on any of these
  // may carry a message, an answer, a conversation title, a filename or a chart
  // label. src/app-assistant/appAssistantTracking.ts is the only module allowed to
  // fire them, and it is what enforces that.
  APP_ASSISTANT_TURN_SEND: 'Action: App Assistant: send message',
  APP_ASSISTANT_TURN_FIRST_TOKEN: 'Action: App Assistant: first token',
  APP_ASSISTANT_TURN_SETTLED: 'Action: App Assistant: turn settled',
  APP_ASSISTANT_OPEN: 'Action: App Assistant: open drawer',
  APP_ASSISTANT_CLOSE: 'Action: App Assistant: close drawer',
  APP_ASSISTANT_TAB_CHANGE: (tab: string) => `Action: App Assistant tab switch: ${tab}`,
  APP_ASSISTANT_NEW_CHAT: 'Action: App Assistant: start new chat',
  APP_ASSISTANT_RESUME_CONVERSATION: 'Action: App Assistant: resume conversation',
  APP_ASSISTANT_STARTER_PICK: 'Action: App Assistant: pick starter question',
  APP_ASSISTANT_COPY_ANSWER: 'Action: App Assistant: copy answer',
  APP_ASSISTANT_TRY_AGAIN: 'Action: App Assistant: try again after error',
  APP_ASSISTANT_KNOWLEDGE_UPLOAD: 'Action: App Assistant knowledge: upload document',
  APP_ASSISTANT_KNOWLEDGE_DELETE: 'Action: App Assistant knowledge: delete document',
  APP_ASSISTANT_CHART_RENDER: 'Action: App Assistant chart: render',
  APP_ASSISTANT_RESIZE: 'Action: App Assistant: resize panel',
  APP_ASSISTANT_THEME_TOGGLE: 'Action: App Assistant: toggle theme',
  APP_ASSISTANT_CONFLICT_RELOAD: 'Action: App Assistant: reload moved conversation',
};
